import { graphql } from '@prophecy/graphql-types/graphql';
export const deleteEntityQuery = graphql(`
  mutation removeEntity($uid: String!, $entityKind: EntityKind!) {
    removeEntity(uid: $uid, entityKind: $entityKind) {
      _id
    }
  }
`);
export const updateEntityAspectQuery = graphql(`
  mutation upsertAspect($uid: String!, $entityKind: EntityKind!, $aspectKind: AspectKind!, $aspectValue: String!) {
    upsertAspect(uid: $uid, entityKind: $entityKind, aspectKind: $aspectKind, aspectValue: $aspectValue)
  }
`);
export const updateTeamInfoSettingsQuery = graphql(`
  mutation updateTeamInfoSettings(
    $teamUID: String!
    $transpilerEnabled: Boolean
    $description: String
    $entraIdEnabled: Boolean
    $assumedRoleEnabled: Boolean
  ) {
    updateTeamInfoSettings(
      teamUID: $teamUID
      transpilerEnabled: $transpilerEnabled
      description: $description
      entraIdEnabled: $entraIdEnabled
      assumedRoleEnabled: $assumedRoleEnabled
    )
  }
`);
export const updateEntityVersionedAspectQuery = graphql(`
  mutation upsertVersionedAspect(
    $uid: String!
    $entityKind: EntityKind!
    $aspectKind: AspectKind!
    $aspectValue: String!
  ) {
    upsertAspect(uid: $uid, entityKind: $entityKind, aspectKind: $aspectKind, aspectValue: $aspectValue)
  }
`);
export const updateEntityFieldQuery = graphql(`
  mutation updateEntity(
    $uid: String!
    $entityKind: EntityKind!
    $entityFieldName: String!
    $entityFieldValue: String!
  ) {
    updateEntity(
      uid: $uid
      entityKind: $entityKind
      entityFieldName: $entityFieldName
      entityFieldValue: $entityFieldValue
    )
  }
`);
